import {createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppState } from "app/store";

interface ErrorSliceState {
    errors: {
        errorMessage: string
    };
    isApiError: boolean
    apiConfig : any,
    isAccessError:boolean,
    isAssessmentNotAvailableError:boolean,
    isMultipleLoginError: boolean;
    isSubmitApiError: boolean;
}

const initialState: ErrorSliceState = {
    errors: {
        errorMessage: ''
    },
    isApiError: false,
    isSubmitApiError: false,
    apiConfig : null,
    isAccessError : false,
    isAssessmentNotAvailableError: false,
    isMultipleLoginError : false
}


export const errorSlice = createSlice({
    name: 'errorReducer',
    initialState,
    reducers: {
        setError: (state, { payload }: PayloadAction<string>) => {
            state.errors = { ...state.errors, errorMessage: payload };
        },
        clearError: (state) => {
            state.errors = { errorMessage: '' }
        },
        setApiError: (state, action: PayloadAction<boolean>) => {
            state.isApiError = action.payload
        },
        setSubmitApiError: (state, action: PayloadAction<boolean>) => {
            state.isSubmitApiError = action.payload
        },
        setApiConfig : (state , action : PayloadAction<any>) => {
            state.apiConfig =  action.payload
        },
        setMultipleLoginError : (state , action:PayloadAction<boolean>) => {
            state.isMultipleLoginError =  action.payload
        },
        setAccessError : (state , action:PayloadAction<boolean>) => {
            state.isAccessError =  action.payload
        },
        setAssessmentNotAvailableError : (state , action:PayloadAction<boolean>) => {
            state.isAssessmentNotAvailableError =  action.payload
        },
    }
})

export default errorSlice.reducer

export const { setMultipleLoginError,setError,clearError,setApiError,setSubmitApiError,setApiConfig,setAccessError,setAssessmentNotAvailableError} = errorSlice.actions

export const selectErrors = (state: AppState): { errorMessage: string } => state.errorReducer.errors;
export const isApiErrorSelector = (state:AppState) => state.errorReducer.isApiError;
export const isSubmitApiErrorSelector = (state:AppState) => state.errorReducer.isSubmitApiError
export const apiConfigSelector = (state:AppState) => state.errorReducer.apiConfig
export const isAccessErrorSelector = (state:AppState) => state.errorReducer.isAccessError
export const isAssessmentNotAvailableErrorSelector = (state:AppState) => state.errorReducer.isAssessmentNotAvailableError
export const isMultipleLoginErrorSelector = (state:AppState) => state.errorReducer.isMultipleLoginError
